import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import routes from "./libs/routes";
import Quick_menu from "./components/quick_menu";
import Header from "./components/header";
import Footer from "./components/footer";

import Main from "./pages/main";
import Login from "./pages/login";
import Register from "./pages/register/Register";
import Login_pw_help from "./pages/register/Login_pw_help";
import Support from "./pages/support/Support";
import Inquiry from "./pages/support/Inquiry";
import Price from "./pages/support/Price";
import Profile from "./pages/mypage/Profile";
import ProfileEdit from "./pages/mypage/ProfileEdit";
import ProfileCoupon from "./pages/mypage/ProfileCoupon";
import BuyList from "./pages/mypage/BuyList";
import CancelSub from "./pages/mypage/CancelSub";
import PayList from "./pages/mypage/PayList";
import CardList from "./pages/mypage/CardList";
import InquiryList from "./pages/mypage/InquiryList";
import PlusMember from "./pages/mypage/PlusMember";
import PlusAdmin from "./pages/mypage/PlusAdmin";
import Licensing from "./pages/mypage/Licensing";
import PlusGroup from "./pages/mypage/PlusGroup";
import Education from "./pages/support/Education";
import Modeling from "./pages/header_function/Modeling";
import PModeling from "./pages/header_function/PModeling";
import UV_Editing from "./pages/header_function/UV_Editing";
import Painting from "./pages/header_function/Painting";
import Rigging from "./pages/header_function/Rigging";
import Intergration from "./pages/header_function/Intergration";
import Extension from "./pages/header_function/Extension";
import AI from "./pages/header_function/AI";
import Library from "./pages/header_function/Library";
import GameDev from "./pages/header_solution/GameDev";
import Metaverse from "./pages/header_solution/Metaverse";
import Indust from "./pages/header_solution/Indust";
import Edu from "./pages/header_solution/Edu";
import Term from "./pages/term/Term";
import { setData } from "./redux/etcSlice";
import * as API from "./libs/service";
import styled from "styled-components";

const FullWidthContent = styled.div`
  width: 100%;
  & * {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
`;

const Layout = ({ onOpenCookieSettings }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { topBanner } = useSelector(s => s.etcReducer);
    const { mbData } = useSelector(s => s.usersReducer);

    const lang = useSelector(state => state.langReducer.lang);
    const terms = useSelector(state => state.etcReducer?.terms || undefined);

    const getTitle = (key) => {
        if (terms && terms[key]) {
            return terms[key][lang === 0 ? 'ko' : 'en']['sub'];
        } else {
            return '';
        }
    }

    const hideTopBtm = ["/login", "/Login_pw_help", "/Register"];

    useEffect(() => {
        API.get("etc/terms")
            .then((data) => {
                const termsData = {};
                const dataToIterate = Array.isArray(data) ? data : data.data;
                dataToIterate.forEach((record) => {
                    const termKey = record.term;
                    const lang = record.lang;
                    if (!termsData[termKey]) {
                        termsData[termKey] = { ko: { sub: "", content: "" }, en: { sub: "", content: "" } };
                    }
                    termsData[termKey][lang] = {
                        sub: record.subTitle || "",
                        content: record.content || "",
                    };
                });
                dispatch(setData({ key: "terms", value: termsData }));
            })
            .catch((error) => {
                console.error("Failed to fetch terms:", error);
            });
    }, [dispatch]);

    const [showTerm, setShowTerm] = useState(undefined);

    useEffect(() => {
        console.log(location.pathname);
        if(location.pathname?.includes('terms') || location.pathname?.includes('privacy')){
            if(terms?.Terms){
                const currentLang = location.pathname?.includes('ko') ? 'ko' : 'en';
                let temkeys = location.pathname?.includes('terms') ? 'Terms' : 'Privacy';
                const sub = terms[temkeys][currentLang].sub || '';
                const content = terms[temkeys][currentLang].content || '';
                setShowTerm(content);
            }
        } else {
            setShowTerm(undefined);
        }

    }, [location.pathname, terms]);

    const sanitizedHtml = showTerm ? showTerm.replace(/max-width\s*:\s*[^;]+;?/gi, '') : '';

    return (
        <>
            {!hideTopBtm.includes(location.pathname) && <Header />}
            {showTerm ? (
                <div style={{ padding: "20px", textAlign: "left", width: "100%", marginTop: 80 }}
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                />
            ) : (
                <Routes>
                    <>
                        <Route exact path="/" element={<Main />} />
                        <Route exact path={routes.login} element={<Login />} />
                        <Route exact path={routes.Register} element={<Register />} />
                        <Route exact path={routes.Login_pw_help} element={<Login_pw_help />} />

                        {/* 헤더 기능 탭 */}
                        <Route exact path={routes.Modeling} element={<Modeling />} />
                        <Route exact path={routes.PModeling} element={<PModeling />} />
                        <Route exact path={routes.UV_Editing} element={<UV_Editing />} />
                        <Route exact path={routes.Painting} element={<Painting />} />
                        <Route exact path={routes.Rigging} element={<Rigging />} />
                        <Route exact path={routes.Intergration} element={<Intergration />} />
                        <Route exact path={routes.Extension} element={<Extension />} />
                        <Route exact path={routes.AI} element={<AI />} />
                        <Route exact path={routes.Library} element={<Library />} />

                        {/* 헤더 솔루션 탭 */}
                        <Route exact path={routes.GameDev} element={<GameDev />} />
                        <Route exact path={routes.Metaverse} element={<Metaverse />} />
                        <Route exact path={routes.Indust} element={<Indust />} />
                        <Route exact path={routes.Edu} element={<Edu />} />

                        {/* 헤더 메뉴 */}
                        <Route exact path={routes.Support} element={<Support />} />
                        <Route exact path={routes.Inquiry} element={<Inquiry />} />
                        <Route exact path={routes.Price} element={<Price />} />
                        <Route exact path={routes.Education} element={<Education />} />

                        {/* 프로필 메뉴 */}
                        <Route exact path={routes.Profile} element={<Profile />} />
                        <Route exact path={routes.ProfileEdit} element={<ProfileEdit />} />
                        <Route exact path={routes.ProfileCoupon} element={<ProfileCoupon />} />
                        <Route exact path={routes.BuyList} element={<BuyList />} />
                        <Route exact path={routes.CancelSub} element={<CancelSub />} />
                        <Route exact path={routes.PayList} element={<PayList />} />
                        <Route exact path={routes.CardList} element={<CardList />} />
                        <Route exact path={routes.InquiryList} element={<InquiryList />} />
                        <Route exact path={routes.PlusMember} element={<PlusMember />} />
                        <Route exact path={routes.PlusAdmin} element={<PlusAdmin />} />
                        <Route exact path={routes.Licensing} element={<Licensing />} />
                        <Route exact path={routes.PlusGroup} element={<PlusGroup />} />
                        <Route exact path={routes.Term} element={<Term />} />
                    </>
                </Routes>
            )}
            {!hideTopBtm.includes(location.pathname) && (
                <Footer onTermSelect={(termKey) => {
                    if (termKey) {
                        const currentLang = lang === 0 ? 'ko' : 'en';
                        const sub = terms[termKey][currentLang].sub || '';
                        const content = terms[termKey][currentLang].content || '';

                        setShowTerm(content);
                        //navigate(routes.Term, {});
                    } else {
                        setShowTerm(undefined);
                    }
                }} onOpenCookieSettings={onOpenCookieSettings} />
            )}
        </>
    );
}

export default Layout;